export default {
	sec_01: {
		title: {
			one: '결제하기',
			two: 'JP WORLD',
			three: 'Pay',
		},
		desc: {
			one: '원하는 암호화폐를 추가하고 원하는 곳에서',
			two: '유연하게 쇼핑을 경험하시기 바랍니다.',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_02: {
		title: {
			one: '전자지갑에만 있는 암호화폐를 JP WORLD PAY를 통해',
			two: '어디서든 간편하게 쇼핑을 즐기시기 바랍니다.',
		},
		step: {
			one: {
				one: '원하는 암호화폐',
				two: '지갑을 만드세요',
				three: 'JP WORLD Pay에',
			},
			two: {
				one: '쇼핑몰 결제시',
				two: 'JP WORLD Pay',
				three: '를 선택하세요.',
			},
			three: {
				one: '원하는 암호화폐로',
				two: '결제하세요.',
				three: 'JP WORLD Pay를 통해',
			},
		},
	},
	sec_03: {
		title: {
			one: '다시 한 번 즐기시기 바랍니다.',
		},
		desc: {
			one: '구입하고 포인트를 받아',
			two: 'JP WORLD Pay,로',
			three: '또 한 번 구입하시기 바랍니다.',
			four: 'JPWORLDPAY 포인트는',
			five: '모든 가맹점에서 사용이 가능합니다.',
			six: 'JP WORLD Pay.를 사용하는',
		},
	},
	sec_04: {
		title: {
			one: '안심하고 결제하세요.',
		},
		desc: {
			one: "JP WORLD Pay's",
			two: '의 보안은 세계 최고를 자랑합니다.',
			three: '고객님의 암호화폐와 자산을 안전하게 지켜드리고',
			four: '안전하게 사용 할 수 있게 해드립니다.',
		},
	},
};
